export enum CorporationType {
  CORPORATION = 'CORPORATION',
  INVESTMENT_VEHICLE = 'INVESTMENT_VEHICLE',
}
